(function () {
  var SECTION_TYPE = 'hero-living-oceans';
  var ytApiPromise = null;

  function loadYouTubeApi() {
    if (ytApiPromise) return ytApiPromise;

    ytApiPromise = new Promise(function (resolve) {
      if (window.YT && typeof window.YT.Player === 'function') {
        resolve(window.YT);
        return;
      }

      var prev = window.onYouTubeIframeAPIReady;
      window.onYouTubeIframeAPIReady = function () {
        if (typeof prev === 'function') {
          try { prev(); } catch (e) {}
        }
        resolve(window.YT);
      };

      if (!document.querySelector('script[data-hero-lo-yt]')) {
        var tag = document.createElement('script');
        tag.src = 'https://www.youtube.com/iframe_api';
        tag.async = true;
        tag.setAttribute('data-hero-lo-yt', '');
        document.head.appendChild(tag);
      }
    });

    return ytApiPromise;
  }

  function buildYouTubeBackground(container) {
    var host = container.querySelector('[data-yt-bg]');
    var videoId = container.dataset.youtubeId;
    if (!host || !videoId) return;

    loadYouTubeApi().then(function (YT) {
      var mount = document.createElement('div');
      host.innerHTML = '';
      host.appendChild(mount);

      new YT.Player(mount, {
        videoId: videoId,
        host: 'https://www.youtube-nocookie.com',
        playerVars: {
          autoplay: 1,
          mute: 1,
          loop: 1,
          playlist: videoId,
          controls: 0,
          showinfo: 0,
          modestbranding: 1,
          rel: 0,
          iv_load_policy: 3,
          playsinline: 1,
          disablekb: 1,
          fs: 0
        },
        events: {
          onReady: function (event) {
            try { event.target.mute(); event.target.playVideo(); } catch (e) {}
            container.setAttribute('data-yt-ready', 'true');
          },
          onStateChange: function (event) {
            if (event.data === YT.PlayerState.ENDED) {
              try { event.target.playVideo(); } catch (e) {}
            }
          }
        }
      });
    });
  }

  function trapFocus(modal, event) {
    if (event.key !== 'Tab') return;
    var focusables = modal.querySelectorAll(
      'a[href], button:not([disabled]), [tabindex]:not([tabindex="-1"]), input, video[controls]'
    );
    if (!focusables.length) return;
    var first = focusables[0];
    var last = focusables[focusables.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  }

  function mountModalPlayer(container, modal) {
    var host = modal.querySelector('[data-hero-lo-video-host]');
    var template = modal.querySelector('[data-hero-lo-template]');
    if (!host) return null;

    host.innerHTML = '';

    if (!template) return null;
    var type = template.getAttribute('data-type');

    if (type === 'youtube') {
      var ytId = template.getAttribute('data-yt-id');
      if (!ytId) return null;

      var mount = document.createElement('div');
      host.appendChild(mount);
      var ytPlayer = null;

      loadYouTubeApi().then(function (YT) {
        ytPlayer = new YT.Player(mount, {
          videoId: ytId,
          playerVars: {
            autoplay: 1,
            playsinline: 1,
            rel: 0,
            modestbranding: 1
          }
        });
      });

      return {
        stop: function () {
          if (ytPlayer && typeof ytPlayer.destroy === 'function') {
            try { ytPlayer.destroy(); } catch (e) {}
          }
          host.innerHTML = '';
        }
      };
    }

    var clone = template.content ? template.content.cloneNode(true) : null;
    if (clone) host.appendChild(clone);

    var media = host.querySelector('video');
    if (media) {
      try {
        media.muted = false;
        var p = media.play();
        if (p && typeof p.catch === 'function') {
          p.catch(function () {
            // Autoplay with sound may be blocked; retry muted.
            media.muted = true;
            media.play().catch(function () {});
          });
        }
      } catch (e) {}
    }

    return {
      stop: function () {
        if (media) {
          try { media.pause(); media.removeAttribute('src'); media.load(); } catch (e) {}
        }
        host.innerHTML = '';
      }
    };
  }

  function initModal(container) {
    var modal = document.getElementById('HeroLoModal-' + container.dataset.sectionId)
      || container.querySelector('.hero-lo-modal');
    if (!modal) return null;

    var openers = container.querySelectorAll('[data-hero-lo-open]');
    var closers = modal.querySelectorAll('[data-hero-lo-close]');
    var lastFocus = null;
    var activePlayer = null;

    function open() {
      lastFocus = document.activeElement;
      modal.hidden = false;
      requestAnimationFrame(function () { modal.classList.add('is-open'); });
      document.body.style.overflow = 'hidden';
      activePlayer = mountModalPlayer(container, modal);
      var closeBtn = modal.querySelector('.hero-lo-modal__close');
      if (closeBtn) closeBtn.focus();
    }

    function close() {
      modal.classList.remove('is-open');
      document.body.style.overflow = '';
      if (activePlayer && typeof activePlayer.stop === 'function') activePlayer.stop();
      activePlayer = null;
      window.setTimeout(function () { modal.hidden = true; }, 200);
      if (lastFocus && typeof lastFocus.focus === 'function') {
        try { lastFocus.focus(); } catch (e) {}
      }
    }

    function onKey(event) {
      if (modal.hidden) return;
      if (event.key === 'Escape') {
        event.preventDefault();
        close();
      } else {
        trapFocus(modal, event);
      }
    }

    openers.forEach(function (btn) { btn.addEventListener('click', open); });
    closers.forEach(function (btn) { btn.addEventListener('click', close); });
    document.addEventListener('keydown', onKey);

    return {
      destroy: function () {
        openers.forEach(function (btn) { btn.removeEventListener('click', open); });
        closers.forEach(function (btn) { btn.removeEventListener('click', close); });
        document.removeEventListener('keydown', onKey);
        if (activePlayer && typeof activePlayer.stop === 'function') activePlayer.stop();
        document.body.style.overflow = '';
      }
    };
  }

  function init(container) {
    if (!container || container.dataset.heroLoBound === 'true') return;
    container.dataset.heroLoBound = 'true';

    if (container.dataset.bgMode === 'youtube') {
      buildYouTubeBackground(container);
    }

    var modal = initModal(container);
    container._heroLoCleanup = function () {
      if (modal && typeof modal.destroy === 'function') modal.destroy();
    };
  }

  function destroy(container) {
    if (!container) return;
    if (typeof container._heroLoCleanup === 'function') container._heroLoCleanup();
    container.dataset.heroLoBound = '';
  }

  function bootstrap(root) {
    (root || document).querySelectorAll('[data-section-type="' + SECTION_TYPE + '"]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { bootstrap(); });
  } else {
    bootstrap();
  }

  document.addEventListener('shopify:section:load', function (e) { bootstrap(e.target); });
  document.addEventListener('shopify:section:unload', function (e) {
    e.target.querySelectorAll('[data-section-type="' + SECTION_TYPE + '"]').forEach(destroy);
  });
  document.addEventListener('shopify:section:select', function (e) { bootstrap(e.target); });
})();
